import './index.less';
import React from 'react';
import PropTypes from 'prop-types';

const PageHeader = ({ title, subtitle, centerTitle = false, centerSubtitle = false }) => {
	return (
		<div className="PageHeader">
			{title && (
				<h1 className={`PageHeader__title ${centerTitle ? 'PageHeader__title--center' : ''} `}>
					{title}
				</h1>
			)}
			{subtitle ? (
				<h2
					className={`PageHeader__subtitle ${centerSubtitle ? 'PageHeader__subtitle--center' : ''}`}
				>
					{subtitle}
				</h2>
			) : null}
		</div>
	);
};

PageHeader.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string
};

export default PageHeader;
